import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Building2, MapPin, Phone } from "lucide-react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Toaster } from "./ui/toaster";
import { Button } from "./ui/button";
import { customers, company } from "../mock";
import useReveal from "../hooks/useReveal";

export default function CustomersPage() {
  useReveal();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App bg-background">
      <Navbar />

      {/* Blue header band */}
      <header className="relative pt-[64px] sm:pt-[70px] bg-gradient-to-br from-[#08234f] via-[#0b2c63] to-[#0e3576] overflow-hidden">
        <div className="absolute inset-0 circuit-bg opacity-[0.15]" />
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-14 sm:py-20">
          <Link
            to="/palvelut"
            className="inline-flex items-center gap-2 text-sky-200 hover:text-white text-sm font-medium transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Takaisin palveluihin
          </Link>
          <span className="mt-4 block text-sm font-semibold tracking-[0.18em] uppercase text-sky-300">
            Käytönjohtajapalvelut
          </span>
          <h1 className="mt-2 font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
            Asiakkaat
          </h1>
          <p className="mt-4 text-slate-200 text-base sm:text-lg max-w-2xl">
            Selekto toimii sähköjärjestelmän käytönjohtajana muun muassa
            seuraaville asiakkaille.
          </p>
        </div>
      </header>

      <main className="py-14 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="flex items-center gap-3 reveal">
            <span className="grid place-items-center w-10 h-10 rounded-lg bg-primary/10 text-primary">
              <Building2 className="w-5 h-5" />
            </span>
            <p className="text-sm text-slate-500">
              <span className="font-semibold text-slate-900">
                {customers.length}
              </span>{" "}
              käytönjohtaja­kohdetta
            </p>
          </div>

          <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {customers.map((c, i) => (
              <div
                key={`${c.name}-${c.location}-${i}`}
                className="reveal rounded-2xl border border-border bg-white p-6 hover:border-primary/30 hover:shadow-[0_18px_40px_-24px_rgba(20,80,180,0.35)] transition-all"
                style={{ animationDelay: `${(i % 3) * 60}ms` }}
              >
                <div className="flex items-start gap-4">
                  <span className="grid place-items-center w-11 h-11 rounded-xl bg-primary text-white shrink-0">
                    <Building2 className="w-5 h-5" />
                  </span>
                  <div className="min-w-0">
                    <h3 className="font-bold text-slate-900 leading-snug">
                      {c.name}
                    </h3>
                    {c.detail && (
                      <p className="text-sm text-primary font-medium mt-0.5">
                        {c.detail}
                      </p>
                    )}
                    {c.location && (
                      <p className="mt-2 inline-flex items-center gap-1.5 text-xs text-slate-500">
                        <MapPin className="w-3.5 h-3.5 text-primary" />
                        {c.location}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-14 rounded-3xl bg-secondary/60 border border-border p-8 sm:p-10 text-center">
            <h2 className="font-extrabold text-2xl sm:text-3xl text-slate-900">
              Tarvitsetko käytönjohtajan laitteistollesi?
            </h2>
            <p className="mt-3 text-slate-600 max-w-xl mx-auto">
              Kysy lisää käytönjohtajapalveluista – autamme mielellämme.
            </p>
            <div className="mt-6 flex flex-wrap gap-4 justify-center">
              <Button asChild size="lg" className="rounded-full px-7 h-12 gap-2">
                <a href={`tel:${company.phoneRaw}`}>
                  <Phone className="w-4 h-4" />
                  {company.phone}
                </a>
              </Button>
              <Button
                asChild
                size="lg"
                variant="outline"
                className="rounded-full px-7 h-12 border-slate-300 hover:border-primary hover:text-primary"
              >
                <Link to="/palvelut">Kaikki palvelut</Link>
              </Button>
            </div>
          </div>
        </div>
      </main>

      <Footer />
      <Toaster />
    </div>
  );
}
